module.exports = __webpack_public_path__ + "static/media/slider-5.bc5bebd7.jpg";